/**
 * @param {String} appId
 * @param {Object} state
 * @return {Boolean}
 */
export function isTwoWaySyncSupported(appId, state) {
	return state?.apps?.some(app => app.id === appId && app.isTwoWaySyncSupported) ?? false;
}
